










import { Component, Vue } from 'vue-property-decorator';
import { firebaseAuth } from '../server/init';
import usersDB from '../server/init';

@Component({
  components: {},
})


export default class Greeting extends Vue {
  private username: string = '';
  private greeting: any = this.displayGreeting();
  private displayLogin: boolean = true;
  private displayGreeting() {
    const currentTime: any = new Date().getHours();
    if (currentTime < 12) {
      return 'Good morning';
    } else if (currentTime >= 12 && currentTime <= 17) {
      return 'Good Afternoon';
    } else {
      return 'Good Evening';
    }
  }

  private logout() {
    firebaseAuth.signOut().then(() => {
      alert('You have successfully logged out.');
      this.$router.push('/');
      return this.displayLogin = true;
    });
  }

  private created() {
    firebaseAuth.onAuthStateChanged((user) => {
      user = firebaseAuth.currentUser;
      if (user) {
        this.displayLogin = false;
        usersDB.collection('users').where('user_id', '==', user.uid).get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.username = doc.id;
          });
        });
      } else {
        return this.displayLogin;
      }
    });
  }

}
